import { toCalendarDate } from '../../../utils/UtilFunctions';

export interface ExecutionMismatch {
  /** El día programado, como día-calendario. */
  scheduled: Date | null;
  /** El día en que realmente entrenó, en la zona del coach. */
  executed: Date | null;
  /** True solo si sabemos las dos fechas y caen en días distintos. */
  mismatch: boolean;
}

/** Medianoche local del instante dado. */
function localDay(value: string | Date | null | undefined): Date | null {
  if (!value) return null;
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return null;
  return new Date(d.getFullYear(), d.getMonth(), d.getDate());
}

/**
 * Compara cuándo estaba programada una sesión contra cuándo se hizo (#6 ítem 3).
 *
 * Las dos fechas se leen DISTINTO a propósito:
 *  - `sessionDate` es un día-calendario guardado a medianoche UTC, así que sus
 *    partes se leen en UTC (toCalendarDate).
 *  - `executedAt` es un instante real —se sella con `new Date()` al completar—,
 *    así que su día es el LOCAL: el día en que el coach lo vio entrenar.
 *
 * Leer las dos igual produce alertas fantasma: alguien que entrena 21:30 en ART
 * queda registrado al día siguiente en UTC y aparecería como "entrenó otro día".
 */
export function getExecutionMismatch(
  sessionDate: string | Date | null | undefined,
  executedAt: string | Date | null | undefined
): ExecutionMismatch {
  const scheduled = toCalendarDate(sessionDate);
  const executed = localDay(executedAt);

  return {
    scheduled,
    executed,
    mismatch: scheduled !== null && executed !== null && scheduled.getTime() !== executed.getTime()
  };
}
